const DOWNGRADED_TO_FREE = 'Downgraded to Free';
const DEACTIVATED_ACCOUNT = 'Deactivated Account';
const REVIEW_PLANS = 'Review Plans';
const UPGRADE_PLAN = 'Upgrade Plan';
const ESSENTIALS_SELECTED = 'Essentials Selected';
const PRO_REDUCED_SELECTED = 'Pro Reduced Selected';

const subscriptionAnalyticsConstants = {
  DOWNGRADED_TO_FREE,
  DEACTIVATED_ACCOUNT,
  REVIEW_PLANS,
  UPGRADE_PLAN,
  ESSENTIALS_SELECTED,
  PRO_REDUCED_SELECTED,
};

export default subscriptionAnalyticsConstants;
